"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _TwoMediaRightTopTextLayout = require("./TwoMediaRightTopTextLayout");
Object.keys(_TwoMediaRightTopTextLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _TwoMediaRightTopTextLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _TwoMediaRightTopTextLayout[key];
        }
    });
});
